/**
 * Global ambient-audio controller. Wraps the single [data-audio] element (if
 * present on the page) and exposes window.tamreAudio so any component — the
 * intro-portal entry, the header sound bars — can drive the same sound.
 *
 * Plain script, no dependencies. Volume is owned by the caller (the intro
 * ramps it up on entry); this only handles play/pause/state.
 */
(function () {
  if (window.tamreAudio) return;

  function init() {
    var el = document.querySelector('[data-audio]');
    if (!el || !el.getAttribute('src')) return; // no audio on this page

    var listeners = [];
    function isPlaying() {
      return !el.paused && !el.ended;
    }
    function emit() {
      for (var i = 0; i < listeners.length; i++) listeners[i](isPlaying());
    }
    el.addEventListener('play', emit);
    el.addEventListener('pause', emit);
    el.addEventListener('ended', emit);

    window.tamreAudio = {
      el: el,
      play: function () {
        var p = el.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      },
      pause: function () {
        el.pause();
      },
      toggle: function () {
        if (el.paused) this.play();
        else this.pause();
      },
      isPlaying: isPlaying,
      onChange: function (cb) {
        listeners.push(cb);
        cb(isPlaying()); // prime with current state
      }
    };

    document.dispatchEvent(new CustomEvent('tamre:audio-ready'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
